// extracted by mini-css-extract-plugin
export var option = "_2p-0";
export var optionSelected = "_2p-1 _2p-0";
export var optionUnselected = "_2p-2 _2p-0";
export var radioInner = "_2p-5";
export var radioOuter = "_2p-3";
export var radioOuterSelected = "_2p-4 _2p-3";